import { useTranslation } from 'react-i18next';

import { useField } from 'formik';
import { MultiAccountField } from 'fields';
import useFieldMultiAccount from 'hooks/useFieldMultiAccount';

export default function MultiAccount({ customerReference }) {
  const { t } = useTranslation('CreateOrder');
  const [, , { setValue: setDebtOwner }] = useField('debtOwner');

  const { handleChange } = useFieldMultiAccount('CreateOrder');

  const handleMultiAccountChange = (currentVal, prevVal) => {
    const selectedDebtOwner = handleChange(currentVal, prevVal);
    setDebtOwner(selectedDebtOwner);
  };

  return (
    <MultiAccountField
      name={'multiAccount'}
      label={t('CustomerDetails.labels.multiAccount')}
      placeholder={t('CustomerDetails.placeholders.multiAccount')}
      onChange={handleMultiAccountChange}
      onCloseIconClick={handleMultiAccountChange}
      customerReference={customerReference}
    />
  );
}
